import {
    payApi,
    resultApi
} from "../../network/api";
const data = function () {
    return {
        showpaymoney: false,
        yue: "",
        paylist: [],
        paymuchmoney: "",
        saomab: false,
        saomaimg: require("../../assets/u=3249012985,3204939794&fm=15&gp=0.jpg"),
        http_url: "",
        order_id: "",
        pay_params: {},
        totleMoney: '',
        huilv: '',
        shouxu: '',
        zhrmb: "",
        paytip: ""
    };
}
const computed = {};
const methods = {
    saoma(e) {
        if (this.paymuchmoney == "") {
            this.$message({
                message: "请先选择充值金额！！！",
                type: "warning",
            });
        } else {
            this.saomab = true;
            if (e == 2) {
                let formdata = {
                    token: this.$store.state.userinfo.token,
                    money: this.paymuchmoney,
                    pay_type: e,
                };
                payApi(formdata)
                    .then((res) => {
                        // console.log(res);

                        if (res.data.code == 0) {
                            var timer = "";
                            this.saomaimg = res.data.data.qrcode;
                            let orderdata = {
                                token: this.$store.state.userinfo.token,
                                order_id: res.data.data.order_id,
                                type: 2,
                            };

                            timer = setInterval(() => {
                                resultApi(orderdata).then((res) => {
                                    // console.log(res);
                                    if (res.data.code == 0) {
                                        clearInterval(timer);
                                        this.$message({
                                            message: "支付成功",
                                            type: "success",
                                        });
                                        setTimeout(() => {
                                            window.location.reload();
                                        }, 1000);
                                        return;
                                    }
                                });
                            }, 1000);
                        } else {
                            this.$message({
                                message: res.data.msg,
                            });
                        }
                    })
                    .catch();
            }
            if (e == 3) {
                let formdata = {
                    token: this.$store.state.userinfo.token,
                    money: this.paymuchmoney,
                    pay_type: e,
                };
                payApi(formdata)
                    .then((res) => {
                        console.log(res);
                        if (res.data.code == 2) {
                            this.http_url = res.data.data.http_url;
                            this.order_id = res.data.data.order_id;
                            this.pay_params = res.data.data.pay_params;
                        }
                    })
                    .catch();
                setTimeout(() => {
                    this.$refs.form.submit()
                }, 1200);

            }
        }
    },
};

export default {
    data,
    computed,
    methods,
};